/** @format */

export const InfoSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.66634 6.00004H7.33301V4.66671L8.66634 4.66671V6.00004ZM8.66634 11.3334H7.33301V7.33337H8.66634L8.66634 11.3334ZM8.00634 14.6667C11.6863 14.6667 14.6663 11.68 14.6663 8.00004C14.6663 4.32004 11.6863 1.33337 8.00634 1.33337C4.31967 1.33337 1.33301 4.32004 1.33301 8.00004C1.33301 11.68 4.31967 14.6667 8.00634 14.6667ZM7.99967 2.66671C10.9463 2.66671 13.333 5.05337 13.333 8.00004C13.333 10.9467 10.9463 13.3334 7.99967 13.3334C5.05301 13.3334 2.66634 10.9467 2.66634 8.00004C2.66634 5.05337 5.05301 2.66671 7.99967 2.66671Z"
                fill={color}
            />
        </svg>
    );
};
